import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

/** Выпадающее меню: trigger — функция (open, toggle) => элемент; закрывается по клику вне и Escape */
export function Dropdown({ trigger, children, align = 'right', className }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div ref={ref} className="relative">
      {trigger(open, () => setOpen((v) => !v))}
      {open && (
        <div
          role="menu"
          className={clsx(
            'absolute z-40 mt-2 min-w-[14rem] animate-scale-in rounded-xl border border-zinc-200 bg-white p-1 shadow-pop dark:border-zinc-700 dark:bg-zinc-900',
            align === 'right' ? 'right-0' : 'left-0',
            className
          )}
          onClick={(e) => { if (e.target.closest('[data-close]')) setOpen(false); }}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export function DropdownItem({ icon: Icon, children, onClick, active, tone, ...props }) {
  return (
    <button
      type="button"
      role="menuitem"
      data-close
      onClick={onClick}
      className={clsx(
        'flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-left text-sm transition-colors',
        tone === 'danger'
          ? 'text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/40'
          : 'text-zinc-700 hover:bg-zinc-100 dark:text-zinc-200 dark:hover:bg-zinc-800',
        active && 'bg-zinc-100 font-medium dark:bg-zinc-800'
      )}
      {...props}
    >
      {Icon && <Icon className="h-4 w-4 shrink-0 text-zinc-400" />}
      <span className="flex-1">{children}</span>
    </button>
  );
}

export function DropdownLabel({ children }) {
  return <p className="px-2.5 pb-1 pt-2 text-[11px] font-semibold uppercase tracking-wide text-zinc-400">{children}</p>;
}

export function DropdownDivider() {
  return <div className="my-1 h-px bg-zinc-100 dark:bg-zinc-800" />;
}
